import { render, staticRenderFns } from "./StreamLamp.vue?vue&type=template&id=cdc5a93a&scoped=true&"
var script = {}
import style0 from "./StreamLamp.vue?vue&type=style&index=0&id=cdc5a93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc5a93a",
  null
  
)

export default component.exports